import axios from 'axios';
import Config from 'Config';
import { createSignedRequest } from 'utils/createSignedRequest';

const isSuccessOrNotFound = (status) =>
  (status >= 200 && status < 300) || status === 404;

export const getProjectConfiguration = async (projectId) => {
  const apiPath = `projects/${projectId}/get-project-configuration`;

  const request = {
    url: `https://${process.env.REACT_APP_WORK_CALENDAR_API_URL}/${apiPath}`,
    // url: `http://localhost:3001/${apiPath}`,
    host: process.env.REACT_APP_WORK_CALENDAR_API_URL,
    path: apiPath,
    method: 'GET',
    region: Config.AWS_REGION,
    service: 'execute-api',
  };
  const signedRequest = await createSignedRequest(request);

  const response = await axios({
    ...signedRequest,
    validateStatus: isSuccessOrNotFound,
  });

  if (response.status === 404 || response.data == null || response.data === '') {
    return null;
  }

  return response.data;
};
